// extracted by mini-css-extract-plugin
export default {"header":"header___Lb7Ci","cards":"cards___e67X3","card":"card___lQWAh","card_text":"card_text___tszZt"};